export default {
  common: {
    actions: {
      save: '',
      cancel: '',
      confirm: '',
      delete: '',
      edit: '',
      add: '',
      close: '',
      back: '',
      next: '',
      finish: '',
      search: '',
      filter: '',
      clear: '',
      download: '',
      upload: '',
      copy: '',
      duplicate: '',
      view: '',
      send: '',
      resend: '',
      activate: '',
      deactivate: '',
      block: '',
      unblock: '',
      approve: '',
      reject: '',
      import: '',
      export: '',
      remove: '',
      create: '',
      update: '',
      yes: '',
      no: '',
      ok: '',
      retry: '',
      refresh: ''
    },
    fields: {
      name: '',
      email: '',
      phone: '',
      document: '',
      cpf: '',
      cnpj: '',
      cpfOrCnpj: '',
      birthDate: '',
      date: '',
      startDate: '',
      endDate: '',
      description: '',
      observation: '',
      type: '',
      status: '',
      value: '',
      code: '',
      country: '',
      state: '',
      city: '',
      zipCode: '',
      address: '',
      number: '',
      complement: '',
      neighborhood: '',
      period: '',
      bank: '',
      agency: '',
      account: '',
      digit: '',
      pixKey: '',
      notes: '',
      optional: ''
    },
    status: {
      active: '',
      inactive: '',
      pending: '',
      approved: '',
      rejected: '',
      cancelled: '',
      completed: '',
      processing: '',
      waiting: '',
      loading: '',
      noData: '',
      noResults: ''
    },
    empty: {
      title: '',
      subtitle: '',
      noFilters: ''
    },
    tooltips: {
      copy: '',
      copied: '',
      download: '',
      remove: '',
      edit: '',
      view: '',
      add: '',
      filter: '',
      closeToast: ''
    },
    confirm: {
      deleteTitle: '',
      deleteSubtitle: '',
      unsavedTitle: '',
      unsavedSubtitle: ''
    },
    feedback: {
      savedSuccess: '',
      deletedSuccess: '',
      copiedSuccess: '',
      requiredFields: '',
      loadError: '',
      saveError: ''
    },
    filters: {
      startDate: '',
      endDate: '',
      type: '',
      status: '',
      bank: '',
      corban: '',
      personType: '',
      cpfCnpj: '',
      nature: '',
      operation: '',
      period: ''
    },
    pagination: {
      rowsPerPage: '',
      of: '',
      all: ''
    }
  },

  validation: {
    required: '',
    email: '',
    minLength: '',
    maxLength: '',
    cpf: '',
    cnpj: '',
    cpfOrCnpj: '',
    phone: '',
    zipCode: '',
    passwordMatch: '',
    passwordMinLength: '',
    numeric: '',
    positiveValue: '',
    percentageRange: '',
    partnersSum: '',
    fileType: '',
    fileSize: '',
    onlyImages: '',
    swiftFormat: '',
    ibanFormat: '',
    stateFormat: '',
    duimpSum: '',
    ssnFormat: ''
  },

  http: {
    unauthorized: '',
    forbidden: '',
    notFound: '',
    tooLarge: '',
    tooManyRequests: '',
    badGateway: '',
    serviceUnavailable: '',
    timeout: '',
    noConnection: ''
  },

  login: {
    emailLabel: '',
    passwordLabel: '',
    loginButton: '',
    forgotPassword: '',
    resetInstructions: '',
    sendCodeButton: '',
    backButton: '',
    codeInstructions: '',
    codeLabel: '',
    confirmButton: '',
    newPasswordInstructions: '',
    newPasswordLabel: '',
    confirmPasswordLabel: '',
    saveButton: '',
    codeSentSuccess: '',
    codeSendError: '',
    codeInvalid: '',
    passwordChangedSuccess: '',
    passwordChangeError: '',
    credentialsRequired: ''
  },

  menu: {
    sections: {
      main: '',
      operational: '',
      reports: '',
      registrations: '',
      administration: '',
      others: ''
    },
    items: {
      home: '',
      dashboard: '',
      customers: '',
      customerFlow: '',
      operations: '',
      preSale: '',
      operationalReports: '',
      internationalRemittances: '',
      profitRemittances: '',
      touristExchange: '',
      stablecoinReports: '',
      duimpManagement: '',
      corban: '',
      registrationsMenu: '',
      commissions: '',
      operationalRegistrations: '',
      operationNatures: '',
      banks: '',
      spreadCurrencies: '',
      paymentMethods: '',
      quotationApis: '',
      templates: '',
      users: '',
      profiles: '',
      audit: '',
      generateInvoices: ''
    },
    customerItems: {
      home: '',
      myAccount: '',
      myOperations: '',
      newOperation: ''
    },
    topbar: {
      whatsapp: '',
      whatsappUnread: '',
      latestUpdates: '',
      pinSidebar: '',
      unpinSidebar: ''
    },
    avatar: {
      title: '',
      choosePhoto: '',
      save: '',
      cancel: '',
      updatedSuccess: '',
      formatError: '',
      sizeError: ''
    },
    language: {
      label: '',
      tooltip: ''
    }
  },

  customerAccess: {
    home: {
      greeting: '',
      myOperations: '',
      noOperations: '',
      viewOperations: '',
      noLimit: '',
      noLimitDescription: '',
      noLimitRequest: '',
      myLimits: '',
      newOperation: '',
      loadBanksError: '',
      loadOperationsError: '',
      loadPreSaleError: ''
    },
    operations: {
      title: '',
      steps: {
        operationType: '',
        operationDetails: '',
        quotation: '',
        summary: '',
        documents: '',
        created: ''
      },
      buttons: {
        finish: '',
        newOperation: '',
        next: '',
        close: '',
        back: ''
      },
      quotationTimer: '',
      loadCurrenciesError: '',
      loadCustomerError: '',
      loadBanksError: '',
      loadQuotationError: '',
      loadDollarError: '',
      submitError: ''
    },
    account: {
      title: '',
      tabs: {
        personalData: '',
        partners: '',
        bankAccounts: '',
        documents: ''
      },
      save: '',
      cancel: '',
      unsavedConfirm: '',
      unsavedTitle: '',
      loadError: '',
      requiredFields: '',
      savedSuccess: '',
      saveError: ''
    },
    detail: {
      sections: {
        customer: '',
        operationNature: '',
        bankAccount: '',
        intermediary: '',
        values: '',
        others: ''
      },
      fields: {
        name: '',
        cpfCnpj: '',
        bank: '',
        agency: '',
        account: '',
        swift: '',
        accountNumber: '',
        holder: '',
        routingAba: '',
        ffc: '',
        iban: '',
        swiftBic: '',
        status: '',
        bankLabel: '',
        operationDate: '',
        exchangeRate: '',
        iof: '',
        ir: '',
        cide: '',
        tariff: '',
        vet: '',
        createdAt: '',
        observationLabel: '',
        operationLabel: ''
      },
      operationTypes: {
        receive: '',
        send: ''
      },
      back: ''
    },
    report: {
      title: '',
      incomeTaxExtract: '',
      tabs: {
        inProgress: '',
        completed: ''
      },
      empty: {
        inProgressTitle: '',
        inProgressSubtitle: '',
        completedTitle: '',
        completedSubtitle: ''
      },
      cancelledAlert: ''
    },
    bankSearch: {
      placeholder: '',
      tooltip: ''
    },
    bankCard: {
      accountName: '',
      fields: {
        holder: '',
        bank: '',
        agency: '',
        checkingAccount: '',
        pix: '',
        iban: '',
        swiftBic: '',
        routingAba: '',
        ffc: ''
      }
    },
    intermediaryBank: {
      fields: {
        country: '',
        bankName: '',
        swiftBic: ''
      }
    }
  },

  stablecoin: {
    approval: {
      enterCode: '',
      approvePayment: '',
      emailLabel: '',
      termsLink: '',
      paymentValue: '',
      steps: {
        code: '',
        sign: '',
        summary: '',
        status: ''
      }
    },
    paymentStatus: {
      title: '',
      payin: '',
      payout: '',
      retry: ''
    },
    limits: {
      title: '',
      increaseTitle: '',
      pendingIncrease: '',
      rejectedIncrease: ''
    },
    documents: {
      checklistTitle: '',
      analysisTitle: ''
    },
    provider: {
      choiceTitle: '',
      linkOnly: ''
    },
    tos: {
      title: '',
      successTitle: ''
    },
    validation: {
      reactivateTitle: ''
    },
    rfi: {
      title: '',
      removeFile: ''
    },
    receiver: {
      pendingIssuesTitle: ''
    }
  },

  dashboard: {
    maxValueTitle: '',
    createScenarioTitle: '',
    scenarioPlaceholder: '',
    deleteScenarioTitle: '',
    deleteScenarioConfirm: '',
    renameTabTitle: '',
    deleteTabTitle: '',
    tabPlaceholder: '',
    widgetSearchPlaceholder: '',
    sharingSearchPlaceholder: '',
    removeDefaultTitle: '',
    selectThemeTitle: '',
    setDefaultSuccess: ''
  },

  reports: {
    searchPlaceholder: '',
    stablecoinSearchPlaceholder: '',
    customerApproval: '',
    tooltips: {
      downloadBankProduct: '',
      manageDuimp: '',
      downloadDoc: '',
      viewRefusal: '',
      manageInvoices: '',
      editShippingDate: ''
    }
  },

  configurations: {
    smtp: {
      title: '',
      server: '',
      port: '',
      tls: '',
      user: '',
      password: '',
      senderName: '',
      senderEmail: '',
      serverPlaceholder: '',
      senderNamePlaceholder: '',
      senderEmailPlaceholder: '',
      deleteTitle: '',
      savedSuccess: '',
      deletedSuccess: ''
    },
    signature: {
      playerPlaceholder: ''
    },
    template: {
      selectPlaceholder: '',
      previewTooltip: ''
    },
    webhook: {
      viewPayload: '',
      resend: ''
    }
  },

  customers: {
    timeline: {
      noStatusHistory: '',
      historyTitle: '',
      banksTitle: '',
      noBanks: ''
    },
    kanbanSearch: '',
    selfieCapture: ''
  },

  registrations: {
    operationNature: {
      examplePlaceholder: ''
    }
  },

  operations: {
    bankLedger: {
      optionalHint: ''
    }
  },

  commissions: {
    search: '',
    emptyTitle: '',
    noCredited: '',
    noRequests: '',
    paymentOrder: {
      brazil: '',
      abroad: '',
      brazilAccount: '',
      abroadAccount: '',
      requestedValue: '',
      invoice: '',
      paidValue: '',
      paymentProof: ''
    },
    filters: {
      startDate: '',
      endDate: ''
    }
  },

  onboarding: {
    steps: {
      welcome: '',
      bank: '',
      client: '',
      corban: '',
      spread: '',
      templates: '',
      triggers: '',
      users: ''
    },
    setup: {
      sidebar: ''
    }
  },

  exchangeClosing: {
    bankCheck: {
      justificationPlaceholder: '',
      missingItemsTitle: ''
    },
    commissions: {
      creditedTitle: '',
      notCreditedTitle: '',
      subtitle: ''
    },
    dateModal: {
      title: ''
    },
    summary: {
      missingItemsTitle: ''
    }
  },

  correspondents: {
    publicSignup: {
      emailHint: ''
    }
  },

  formExchangeBank: {
    cover: {
      playerPlaceholder: '',
      openHoursHint: '',
      closeHoursHint: ''
    },
    financial: {
      requiredHint: '',
      percentageHint: ''
    },
    stores: {
      editTooltip: '',
      duplicateTooltip: ''
    },
    digitalSignatureTitle: ''
  },

  auth: {
    identities: {
      title: '',
      emptyTitle: '',
      emptySubtitle: ''
    },
    googleButton: '',
    googleAriaLabel: '',
    emailLabel: '',
    passwordLabel: ''
  },

  currencyHolidays: {
    emptyTitle: '',
    card: {
      dateLabel: '',
      nameLabel: '',
      saveTooltip: '',
      cancelTooltip: '',
      editTooltip: '',
      removeTooltip: '',
      deleteTitle: ''
    },
    exclusions: {
      title: '',
      emptyTitle: ''
    },
    countryConfig: {
      searchCurrency: ''
    }
  },

  audit: {
    showAll: '',
    hideEmpty: ''
  },

  whatsapp: {
    searchPlaceholder: '',
    phoneDdiHint: ''
  },

  clara: {
    customerPickerPlaceholder: '',
    chatInput: {
      placeholder: '',
      cancelResponse: '',
      speakQuestion: '',
      send: '',
      cancelRecording: ''
    }
  },

  logger: {
    email: {
      title: '',
      preview: ''
    },
    whatsapp: {
      title: '',
      preview: ''
    }
  },

  access: {
    profiles: {
      title: '',
      newProfile: ''
    }
  },

  generic: {
    pageNotFound: {
      title: '',
      subtitle: '',
      backHome: ''
    },
    pageNotPermission: {
      title: '',
      subtitle: '',
      backHome: ''
    }
  }
};
